import { RefillTooSoonReason } from "common/types/carts";

export const refillTooSoonOptions: Record<RefillTooSoonReason, string> = {
  [RefillTooSoonReason.Travel]: "I am traveling and need supply in advance",
  [RefillTooSoonReason.LostOrDamaged]: "Last fill of this medication was lost or damaged",
  [RefillTooSoonReason.DifficultyDosing]:
    "Administration of medication is difficult and additional supply is needed",
};
